/* eslint-disable react/prop-types */

import React, { PureComponent } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
`

const Transition = styled(CSSTransition)`
  transition-duration: 400ms;
  transition-property: transform;
  perspective: 1000;

  /* stylelint-disable block-no-empty */

  /* none */

  &.none-enter {
    z-index: 1;
    transform: translate(0, 0);
  }

  /* fromRight */

  &.fromRight-enter {
    transform: translateX(100%);
    z-index: 1;
  }

  &.fromRight-enter-active {
    transform: translateX(0);
  }

  &.fromRight-enter-done {
    transition: none;
  }

  &.fromRight-exit {
  }

  &.fromRight-exit-active {
    transform: translateX(-30%);
  }

  /* fromRightReverse */

  &.fromRightReverse-enter {
    transform: translateX(-30%);
  }

  &.fromRightReverse-enter-active {
    transform: translateX(0);
  }

  &.fromRightReverse-enter-done {
    transition: none;
  }

  &.fromRightReverse-exit {
    z-index: 1;
  }

  &.fromRightReverse-exit-active {
    transform: translateX(100%);
  }

  /* fromLeft */

  &.fromLeft-enter {
    transform: translateX(-100%);
    z-index: 1;
  }

  &.fromLeft-enter-active {
    transform: translateX(0);
  }

  &.fromLeft-enter-done {
    transition: none;
  }

  &.fromLeft-exit {
  }

  &.fromLeft-exit-active {
    transform: translateX(30%);
  }

  /* fromLeftReverse */

  &.fromLeftReverse-enter {
    transform: translateX(30%);
  }

  &.fromLeftReverse-enter-active {
    transform: translateX(0);
  }

  &.fromLeftReverse-enter-done {
    transition: none;
  }

  &.fromLeftReverse-exit {
    z-index: 1;
  }

  &.fromLeftReverse-exit-active {
    transform: translateX(-100%);
  }

  /* fromTop */

  &.fromTop-enter {
    transform: translateY(-100%);
    z-index: 1;
  }

  &.fromTop-enter-active {
    transform: translateY(0);
  }

  &.fromTop-enter-done {
    transition: none;
  }

  &.fromTop-exit {
  }

  &.fromTop-exit-active {
  }

  /* fromTopReverse */

  &.fromTopReverse-enter {
  }

  &.fromTopReverse-enter-active {
  }

  &.fromTopReverse-enter-done {
    transition: none;
  }

  &.fromTopReverse-exit {
    transform: translateY(0);
    z-index: 1;
  }

  &.fromTopReverse-exit-active {
    transform: translateY(-100%);
  }

  /* fromBottom */

  &.fromBottom-enter {
    transform: translateY(100%);
    z-index: 1;
  }

  &.fromBottom-enter-active {
    transform: translateY(0);
  }

  &.fromBottom-enter-done {
    transition: none;
  }

  &.fromBottom-exit {
  }

  &.fromBottom-exit-active {
  }

  /* fromBottomReverse */

  &.fromBottomReverse-enter {
  }

  &.fromBottomReverse-enter-active {
  }

  &.fromBottomReverse-enter-done {
    transition: none;
  }

  &.fromBottomReverse-exit {
    transform: translateY(0);
    z-index: 1;
  }

  &.fromBottomReverse-exit-active {
    transform: translateY(100%);
  }
  /* stylelint-enable */
`

class IOSTransition extends PureComponent {
  render() {
    const { transition, transitionKey, children } = this.props

    return (
      <TransitionGroup
        childFactory={child =>
          React.cloneElement(child, {
            classNames: transition,
          })
        }>
        <Transition key={transitionKey} timeout={400} classNames={transition}>
          <Wrapper>{children}</Wrapper>
        </Transition>
      </TransitionGroup>
    )
  }
}

export default IOSTransition
